import { render } from "./TransactionStatusDetail.vue?vue&type=template&id=bba36b6e&scoped=true"
import script from "./TransactionStatusDetail.vue?vue&type=script&lang=js"
export * from "./TransactionStatusDetail.vue?vue&type=script&lang=js"

import "./TransactionStatusDetail.vue?vue&type=style&index=0&id=bba36b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bba36b6e"]])

export default __exports__